import {fetch} from "utils/dataAccess";

export function getLogs(itemId, inventoryId) {
    const params = new URLSearchParams()

    params.append('inventoryId', inventoryId);
    params.append('entityId', itemId);
    params.append('order[createdAt]', 'desc');
    params.append('itemsPerPage', '10');

    return new Promise((resolve, reject) => {
        fetch(`/wms_histories?${params.toString()}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved['hydra:member'])
                })
            })
            .catch(error => reject(error));
    })
}
